import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import { AuthContext } from '../../context/AuthContext';
import { CategoriaFinanceiraContext } from '../../context/CategoriaFinanceiraContext';
import { CategoriaFinanceiraType, CreateCategoriaFinanceiraType, UpdateCategoriaFinanceiraType } from '../../context/hooks/useCategoriaFinanceira';
import useUser from '../../context/hooks/useUser';

const CategoriaFinanceira = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listCategoriaFinanceira, categoriaFinanceiraPageCount, getAllCategoriaFinanceiraPaged, createCategoriaFinanceira, updateCategoriaFinanceira, deleteCategoriaFinanceira } = useContext(CategoriaFinanceiraContext);
    const { getPermissionsByUser, userPermissions } = useUser();
    const [newCategoriaFinanceira, setNewCategoriaFinanceira] = useState<CreateCategoriaFinanceiraType>({
        name: '',
        empresaId: objUserTk.EmpresaId,
    });
    const [editingCategoriaFinanceira, setEditingCategoriaFinanceira] = useState<UpdateCategoriaFinanceiraType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);

    const [filters, setFilters] = useState({
        name: '',
    });
    const [dataSearch, setDataSearch] = useState({ name: '' });

    useEffect(() => {
        setLoading(true);
        getAllCategoriaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar categorias:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllCategoriaFinanceiraPaged(value, pageSize, objUserTk.EmpresaId);
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllCategoriaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({ name: '' });
        setLoading(true);
        getAllCategoriaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setNewCategoriaFinanceira(prevCategoriaFinanceira => ({
            ...prevCategoriaFinanceira,
            [name]: value === '' ? null : value
        }));
    };

    const handleCreateCategoriaFinanceira = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const payload = {
            ...newCategoriaFinanceira,
            name: newCategoriaFinanceira.name,
            empresaId: Number(newCategoriaFinanceira.empresaId)
        };

        createCategoriaFinanceira(payload)
            .then(createdCategoriaFinanceira => {
                if (createdCategoriaFinanceira) {
                    setCreateModalOpen(false);
                    setNewCategoriaFinanceira({
                        name: '',
                        empresaId: objUserTk.EmpresaId,
                    });
                    getAllCategoriaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId);
                } else {
                    console.error("Erro ao criar categoria do finaneiro.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar categoria do financeiro:", error);
            });
    };

    const handleEditCategoriaFinanceira = (categoriaFinanceira: CategoriaFinanceiraType) => {
        setEditingCategoriaFinanceira(categoriaFinanceira);
        setEditModalOpen(true);
    };

    const handleEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (editingCategoriaFinanceira) {
            const updatedData = {
                ...editingCategoriaFinanceira,
            };
            updateCategoriaFinanceira(updatedData)
                .then(updatedCategoriaFinanceira => {
                    if (updatedCategoriaFinanceira) {
                        setEditModalOpen(false);
                        getAllCategoriaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId);
                        setEditingCategoriaFinanceira(null);
                    } else {
                        console.error("Erro ao atualizar categoria.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar categoria:", error);
                });
        }
    };

    const handleDeleteCategoriaFinanceira = (categoriaFinanceiraId: number) => {
        if (window.confirm("Tem certeza que deseja excluir esta categoria?")) {
            deleteCategoriaFinanceira(categoriaFinanceiraId)
                .then(deletedCategoriaFinanceira => {
                    if (deletedCategoriaFinanceira) {
                        getAllCategoriaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId);
                    } else {
                        console.error("Erro ao excluir categoria.");
                    }
                    getAllCategoriaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId);
                })
                .catch(error => {
                    console.error("Erro ao excluir categoria:", error);
                });
        }
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Categoria Financeira"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row className="align-items-center mb-4">
                    <Col xs="12" md="9" lg="9" className="mb-2">
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Buscar por nome da categoria"
                            value={dataSearch.name}
                            onChange={handleFilterChange}
                        />
                    </Col>
                    <Col xs="12" md="3" lg="3" className="d-flex justify-content-start justify-content-md-end mb-2">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            type="button"
                            size="m"
                            onClick={handleSearch}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            type="button"
                            size="m"
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col>
                    {userPermissions.includes(1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar categoria
                            </Button>
                        </Col>
                    )}
                </Row>

                {userPermissions.includes(2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Sequência</th>
                                        <th>Nome</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listCategoriaFinanceira.map((categoriaFinanceira: CategoriaFinanceiraType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{categoriaFinanceira.id}</td>
                                                <td>{categoriaFinanceira.name}</td>
                                                <td>
                                                    {userPermissions.includes(3) && (
                                                        <Button onClick={() => { handleEditCategoriaFinanceira(categoriaFinanceira) }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {userPermissions.includes(4) && (
                                                        <Button onClick={() => handleDeleteCategoriaFinanceira(categoriaFinanceira.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            {/* <div className="d-flex justify-content-end mt-3">
                                {categoriaFinanceiraPageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={categoriaFinanceiraPageCount}
                                        />
                                    </div>
                                )}
                                {listCategoriaFinanceira.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div> */}
                            <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                                <div className="mb-2 mb-md-0">
                                    <Label className="form-control-label mr-2">Registros por página:</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        bsSize="sm"
                                        style={{ width: "100px", display: "inline-block" }}
                                        value={pageSize}
                                        onChange={(e) => {
                                            const newSize = parseInt(e.target.value);
                                            setPageSize(newSize);
                                            getAllCategoriaFinanceiraPaged(1, newSize, objUserTk.EmpresaId);
                                        }}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={15}>15</option>
                                        <option value={20}>20</option>
                                        <option value={25}>25</option>
                                    </Input>
                                </div>

                                {categoriaFinanceiraPageCount && (
                                    <div className="mt-2 mt-md-0">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={categoriaFinanceiraPageCount}
                                        />
                                    </div>
                                )}

                                {listCategoriaFinanceira.length === 0 && (
                                    <div className="w-100 mt-3" style={{ color: "red" }}>
                                        NÃO FOI ENCONTRADO NENHUM REGISTRO
                                    </div>
                                )}
                            </div>

                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar as categorias do financeiro.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container >

            <Modal isOpen={createModalOpen} toggle={() => setCreateModalOpen(!createModalOpen)} backdrop="static" size="lg">
                <ModalHeader toggle={() => setCreateModalOpen(!createModalOpen)}>Adicionar nova categoria</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleCreateCategoriaFinanceira}>
                        <Row>
                            <Col md='12'>
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="input-name">
                                        Nome da categoria
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={newCategoriaFinanceira.name}
                                        onChange={handleCreateInputChange}
                                        required
                                        placeholder="Ex: Despesas com marketing, Despesas com vendas, etc."
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-3">
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Criar categoria</Button>
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} onClick={() => setCreateModalOpen(!createModalOpen)} size="m" className="ml-2">Cancelar</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>

            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(!editModalOpen)} backdrop="static" className="custom-modal-xl">
                <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>Editar informações da categoria</ModalHeader>
                <ModalBody>
                    {editingCategoriaFinanceira && (
                        <>
                            <Form onSubmit={handleEditSubmit}>
                                <Row>
                                    <Col md='12'>
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-name">Nome da categoria</Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                name="name"
                                                id="name"
                                                value={editingCategoriaFinanceira.name}
                                                onChange={e => setEditingCategoriaFinanceira({ ...editingCategoriaFinanceira, name: e.target.value })}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div className="d-flex justify-content-end">
                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Salvar alterações</Button>
                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} onClick={() => setEditModalOpen(!editModalOpen)} size="m">Cancelar</Button>
                                </div>
                            </Form>
                        </>
                    )}
                </ModalBody>
            </Modal>
        </>
    );
};

export default CategoriaFinanceira;